import React from 'react';
import { MinimalLayout } from '../layouts/MinimalLayout';
import { Icon } from '../components/Icon';
import { getConfig } from '../config';

const NotFoundPage: React.FC = () => (
  <MinimalLayout className="not-found-page">
    <Icon icon="truck-bolt" />
    <p>We're sorry, this ticket could not be found.</p>
    <a className="bas button primary" href={getConfig().web.url}>
      Go back to BAS World
    </a>
  </MinimalLayout>
);
export default NotFoundPage;
